module.exports = __webpack_public_path__ + "static/awards-bottom-recommended-e420fe453952e6c10fd1c6d386849dc2.gif";